import {connect} from 'react-redux';
import Form_3 from './Form_3';
import {submitStep} from '../../actions/steps/submitStep';
import {uploadFile} from "../../actions/files/uploadFile";
import {getShumaStepStatus} from '../../actions/steps/getShumaStepStatus';
import {showGlobalErrorMessage} from "common/actions/globalErrorMessage/showGlobalErrorMessage";
import {getStepData} from "../../actions/steps/getStepData";
import {getFirmUsers} from "../../../../common/components/DataTableWithFilters/actions/DataTableWithFiltersOptionsActions";
import {getFileList} from '../../actions/files/getFileList';

const mapStateToProps = ({
                           stepData: {stepData},
                           shumaProperties: {shumaTypeID, propertyTypeID},
                           dataTableWithFiltersOptionsReducer: {users},
                           step11FileList: {list: filesListData}
                         }) => ({
  stepData,
  shumaTypeID,
  propertyTypeID,
  users,
  filesListData
});

export default connect(
  mapStateToProps,
  {
    submitStep,
    uploadFile,
    getShumaStepStatus,
    showGlobalErrorMessage,
    getStepData,
    getFirmUsers,
    getFileList
  }
)(Form_3);
